import React from "react";

const IMAGES = {
  samosa: "https://images.pexels.com/photos/28075291/pexels-photo-28075291.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  street: "https://customer-assets.emergentagent.com/job_samosa-nation/artifacts/5579uw8r_Screenshot%202026-06-08%20210901.png",
  fastfood: "https://images.pexels.com/photos/1639557/pexels-photo-1639557.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  chai: "https://images.pexels.com/photos/27498507/pexels-photo-27498507.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
};

export default function MenuShowcase({ t }) {
  const images = [IMAGES.samosa, IMAGES.street, IMAGES.fastfood, IMAGES.chai];

  return (
    <section id="menu" className="relative py-24 md:py-32 bg-stone-base" data-testid="menu-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-amber-500 text-xs uppercase tracking-[0.3em] mb-4">{t.eyebrow}</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-stone-50 leading-tight">{t.title}</h2>
          <p className="mt-5 text-stone-300 text-base md:text-lg leading-relaxed">{t.sub}</p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-6 lg:gap-8">
          {t.cats.map((cat, i) => (
            <article
              key={i}
              data-testid={`menu-card-${i}`}
              className="group heritage-card overflow-hidden flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={images[i]}
                  alt={cat.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-stone-950/95 via-stone-950/30 to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-full bg-amber-600 text-stone-950 text-[10px] uppercase tracking-[0.2em] font-medium">
                    {cat.tag}
                  </span>
                </div>
                <div className="absolute bottom-5 left-6 right-6">
                  <h3 className="font-serif text-2xl md:text-3xl text-stone-50 leading-tight">{cat.title}</h3>
                </div>
              </div>
              <div className="p-6 md:p-7">
                <p className="text-stone-300 leading-relaxed">{cat.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
